import '../src/core/css/global.css';

//import { Navigate, Route, Routes } from 'react-router-dom';
import HomePage from './features/home/HomePage';
import { Widget } from './core';
import { useSchedulingUpdateContext } from './components/context';
import { useEffect, useState } from 'react';
import { CancelScheduling, SessionTimeout } from './components';

interface AppProps {
  practitionerId?: string;
  cattailsProviderId?: string;
  providerName?: string;
}

const App = (props: AppProps) => {
  const schedulingUpdateContext = useSchedulingUpdateContext();

  const [key, setKey] = useState(0);

  const setContextToDefault = () => {
    schedulingUpdateContext.changeSchedulingDetails({
      providerDetails: {
        practitionerId: props.practitionerId ?? '',
        cattailsProviderId: props.cattailsProviderId ?? '',
        name: props.providerName,
      },
    });
  };

  useEffect(() => {
    setContextToDefault();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const onTimeoutCancelScheduling = () => {
    // Reset everything and start over.
    setKey((prevKey) => prevKey + 1);
    setContextToDefault();
  };

  return (
    <Widget key={key}>
      {/* <Routes>
        <Route path="/home" element={<HomePage />} />
        <Route path="/" element={<Navigate to="/home" replace />} />
      </Routes> */}
      <SessionTimeout onCancelScheduling={onTimeoutCancelScheduling} />
      <HomePage />
      <CancelScheduling />
    </Widget>
  );
};

export default App;
